module.exports = __webpack_public_path__ + "static/media/shelcia.1252a3d4.png";